import { Inject, Injectable } from '@angular/core';
import { marker as i18n } from '@ngneat/transloco-keys-manager/marker';
import { map, Observable } from 'rxjs';
import { TranslateFunction } from '@bbraun/shared/util-transloco-ng';
import { createIsNumberLessOrEqualTo } from '@bbraun/shared/util-validation';
import {
  ValidatorFactory,
  ValidatorFactoryFunction,
} from '@bbraun/bav-reporting/ui-report-editor';
import { FeatureAisReportsScopedTranslationService } from '../../../services/feature-ais-reports-scoped-translation.service';

export const IS_LOWER_OR_EQUAL_TO_NUMBER_ID = 'IS_LOWER_OR_EQUAL_TO_NUMBER';
export const IS_LOWER_OR_EQUAL_TO_NUMBER_ERROR = Symbol(
  IS_LOWER_OR_EQUAL_TO_NUMBER_ID,
);

@Injectable({
  providedIn: 'root',
})
export class IsLowerOrEqualToNumberValidatorFactory
  implements ValidatorFactory<{ maximum: number }>
{
  readonly id = IS_LOWER_OR_EQUAL_TO_NUMBER_ID;
  readonly validatorFn: Observable<
    ValidatorFactoryFunction<{ maximum: number }>
  >;

  constructor(
    @Inject(FeatureAisReportsScopedTranslationService)
    private readonly scopedTranslationService: {
      loadedLang$: Observable<{ translate: TranslateFunction }>;
    },
  ) {
    this.validatorFn = this.scopedTranslationService.loadedLang$.pipe(
      map(({ translate }) => ({ maximum }) => ({
        id: IS_LOWER_OR_EQUAL_TO_NUMBER_ERROR,
        validate: createIsNumberLessOrEqualTo(maximum),
        message: translate(
          i18n(
            'bbraunBavReportingFeatureAisReports.validation.isLowerOrEqualToNumber.error.message',
          ),
          { maximum },
        ),
      })),
    );
  }
}
